<template>
  <div class="page-padding">
    <div class="main-carousel">
      <carousel :items-to-show="1" :autoplay="0" :wrap-around="true">
        <slide v-for="slide in slides" :key="slide.id">
          <div v-if="slide.video_url !== ''" class="carousel-item">
            <button id="play-video" @click="playVideo">
              <div v-if="carouselVideo">
                <iframe :src="'https://www.youtube.com/embed/' + slide.video_url.split('/').reverse().slice(0, 1) + '?controls=0&disablekb=1&modestbranding=1&rel=0&fs=0&iv_load_policy=3'" width="100%" height="490"></iframe>
              </div>
              <div v-else>
                <img :src="play" class="play">
                <img :src="slide.image_url" alt="" width="100%" height="490">
              </div>
            </button>
          </div>
          <!-- <div v-if="slide.video_url !== ''" class="carousel-item">
            <button id="show-modal" @click="showVideoModal = true">
              <img :src="play" class="play" >
              <img :src="slide.image_url" alt="">
            </button>
            <Teleport to="body">
              <VideoModal :show="showVideoModal" :slide="slide" @close="showVideoModal = false"></VideoModal>
            </Teleport>
          </div> -->
          <div v-else class="carousel-item">
            <img :src="slide.image_url" alt="" width="100%" height="490">
            <!-- <img :src="slide.image_url" alt="" @click="this.$showMessage('success', 'Your request has not been sent')"> -->
          </div>
        </slide>
        <template #addons>
          <pagination />
        </template>
      </carousel>
    </div>
    <div class="main-page_block">
      <div v-for="data in data" :key="data.id">
        <h1>{{ data.page_title }}</h1>
        <img :src="data.image_url" alt="">
        <div v-html="data.page_desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
  // import MainAlert from '../components/alerts/MainAlert.vue';
  import 'vue3-carousel/dist/carousel.css';
  import { Carousel, Slide, Pagination } from 'vue3-carousel';
  import VideoModal from '../components/VideoModal.vue';
  import Loader from '../components/Loader.vue'
  import { useStepsStore } from '../stores/StepsStore.js';
  import { storeToRefs } from 'pinia'
  import axios from "axios";
  import { inject } from 'vue'

  export default{
    components: {
      Carousel,
      Slide,
      Pagination,
      VideoModal,
      Loader
      // MainAlert
    },
    data() {
      return{
        slides: [],
        showVideoModal: false,
        play: "assets/icons/play.svg",
        loading: true,
        carouselVideo: false,
        data: ''
      }
    },
    mounted() {
      axios
        .get('https://bo.pitstoplecce.it/index.php?r=page/page&id=2')
        .then(data => this.data = data.data)
        .catch((errors) => console.log(errors));
      // fetch('https://pitstop.dev.consolidati.it/_json/home_slides.json')
      fetch('https://bo.pitstoplecce.it/?r=slide/slides')
      .then(res => res.json())
      .then(data => {this.slides = data;this.loadingPage = false})
      .catch(err => console.log(err.message))
    },
    methods: {
      playVideo(){
        this.carouselVideo = true;
      }
    },
    computed: {
  },
    setup() {
      if(window.location.search != ''){
        localStorage.setItem('newsid', window.location.search.split('news=')[1]);
      }
      
      const { loadingPage} = storeToRefs(useStepsStore())
      
      return {
        loadingPage
      };  
    }
  }
</script>

<style scoped>
  .carousel{
    height: 540px;
    margin: 0 0 50px;
  }
  .carousel-item{
    border-radius: 20px;
  }
  .carousel-item,
  .carousel-item button{
    width: 100%;
  }
  .carousel-item img{
    width: 100%;
    height: 490px;
    object-fit: cover;
    border-radius: 20px;
  }
  .carousel-item iframe{
    width: 100%;
    height: 490px;
    border-radius: 20px;
  }
  .carousel-item .play {
    width: 100px;
    height: 60px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    object-fit: fill;
  }
  .main-page_block h1{
    margin: 0 0 30px;
  }
  .main-page_block p{
    font-size: 30px;
    margin: 0 0 20px;
  }
  /* iframe .ytp-watermark, iframe .yt-uix-sessionlink, iframe svg {
    display: none !important;
    position: fixed;
    right: 90000px;
  } */
  /* #play-video>div::before {
    content: '';
    position: absolute;
    width: 101%;
    height: 60px;
    background: #fff;
    left: -1px;
    top: -1px;
  }
  #play-video>div::after {
    content: '';
    position: absolute;
    width: 101%;
    height: 57px;
    background: #fff;
    left: -1px;
    bottom: -1px;
  } */
  .carousel-item iframe {
    height: 630px !important;
    margin-top: -70px !important;
  }
  .carousel-item {
    max-height: 490px;
    overflow: hidden;
    border-radius: 20px;
  }
</style>